// horizon page-config API keys
export const PAGE_KEY = 'proposal_builder_v2' as const
export const RISK_FACTORS_VIEW_KEY = 'risk_factors' as const
export const STATISTICS_VIEW_KEY = 'statistics' as const

// Copy
export const DEFAULT_PROPOSAL_NAME = 'New Proposal'
export const DEFAULT_MODEL_NAME = 'New Model'

// Global constraint IDs
export const GLOBAL_CURRENCY_CONSTRAINT_ID = 'global-currency-constraint'
// Pre-rename id for the global currency constraint, still present on older models.
export const LEGACY_GLOBAL_CURRENCY_CONSTRAINT_ID = 'global-universe-constraint'
export const BOND_STATUS_CONSTRAINT_ID = 'global-bond-status-constraint'
export const STRUCTURED_PRODUCT_CONSTRAINT_ID =
  'global-structured-product-constraint'

// Status poll cadence while the loaded proposal is `running`, whoever started
// the solve. A proposal that is not running is not polled.
export const STATUS_POLL_INTERVAL_MS = 500

// A server read that does not apply is retried after 1s, doubling to a 30s cap.
export const SERVER_READ_RETRY_BASE_MS = 1000
export const SERVER_READ_RETRY_MAX_MS = 30_000

// Debounce times
export const AUTOSAVE_DEBOUNCE_MS = 250 as const
